import React, { useState, useEffect, useContext } from 'react'
import Banner from '../component/Common/Banner'
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { compose } from 'redux'
import { connect } from "react-redux";
import * as actions from "../actions/blog";
import { Link } from 'react-router-dom';
import { RWebShare } from "react-web-share";
import { IoShareSocialOutline, IoChevronBackOutline, IoChevronForwardOutline } from 'react-icons/io5';
import arrow from './../assets/img/custom/arrow.png'
import moment from 'moment';

const Blogs = (props) => {
    const { t, i18n } = useTranslation();
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(12)

    useEffect(() => {
        props.fetchPagination(1, rowsPerPage)
    }, []);

    useEffect(() => {
        console.log('props11>', props)
    }, [props]);


    const handleChangePage = async (newPage) => {
        await setPage(newPage);
        props.fetchPagination(newPage + 1, rowsPerPage)
    };
    const handleSearch = async (searchText) => {
        await setPage(0);
        props.fetchPagination(1, rowsPerPage, searchText, searchText)
    };

    const handleFilterChange = async (title, description) => {
        await setPage(0);
        props.fetchPagination(1, rowsPerPage, title, description)
    };

    return (
        <>

            <Banner title={t('blogs')} />
            <div className='container mb-5 mt-n4'>
                <div className="row">
                    {props.blogs?.map((data, index) => (
                        <div className="col-lg-3 col-12 mb-1" key={index}>
                            <div className="product_wrappers_one">
                                <div className="thumb">

                                    <Link to={{
                                                    pathname: `/blog-details/${(data.name.en).replaceAll(' ', '-').toLowerCase()}/${i18n.language}`
                                                                                       , state: {
                                                                                           service: data
                                                                                       }
                                                                                   }}
                                        className={"image"}>
                                        <img src={process.env.REACT_APP_IMG_URL + data.image} />
                                        <img className="hover-image" src={process.env.REACT_APP_IMG_URL + data.image}
                                        />
                                    </Link>

                                </div>

                                <div className="content blogcontent">
                                    <div className='mb-2'>
                                    <small className='text-warn float-left'>{data?.categoryId?.title[i18n.language]}</small> <small className='float-right font-weight-light' style={{fontSize:10}}>{moment(data.createdDate).format("DD MMM yy")}</small>
                                    </div>  
                                    
                                    <h5 className="title">
                                        <Link to={{
                                                    pathname: `/blog-details/${(data.name.en).replaceAll(' ', '-').toLowerCase()}/${i18n.language}`
                                                                                       , state: {
                                                                                           service: data
                                                                                       }
                                                                                   }} >{data.name[i18n.language]}</Link>
                                    </h5>
                                    <small className='mb-2'>{data.about[i18n.language]?.replace(/<[^>]+>|\n|&nbsp;|&amp;/g, '').slice(0, 60) + '...'}</small>

                                 

                                    <Link to={{
                                                    pathname: `/blog-details/${(data.name.en).replaceAll(' ', '-').toLowerCase()}/${i18n.language}`
                                                                                       , state: {
                                                                                           service: data
                                                                                       }
                                                                                   }} className='text-warn font-weight-light small'>{t('continuereading')} <img src={arrow} style={{ height: 10 }} /></Link>
                                   

                                </div>

                            </div>
                        </div>
                    ))}
                    {props?.meta?.totalPages > 1 && <div className="col-lg-12 col-12 mb-1">
                        <ul className="pagination float-right">
                          {page>0 && <li className="page-item"><a className="page-link bg-white" onClick={() => handleChangePage(page - 1)}><IoChevronBackOutline /> {t('previous')}</a></li>}
                            {Array(props?.meta?.totalPages).fill().map((e, i) => (
                                <li className={`page-item ${page === i  ? "active" : ""}`}><a className="page-link" onClick={() => handleChangePage(i)}>{i + 1}</a></li>
                            ))}
                          {page+1!==props?.meta?.totalPages && <li className="page-item"><a className="page-link bg-white" disabled onClick={() => handleChangePage(page + 1)}>{t('nextt')} <IoChevronForwardOutline /></a></li>}
                        </ul>
                    </div>}
                </div>

            </div>
        </>
    )
}


const mapStateToProps = state => ({
    blogs: state?.blog?.blogs,
    meta: state?.blog?.meta,

})

const mapActionToProps = {

    fetchDepartments: actions.fetchAll,
    fetchPagination: actions.Pagination,
}


export default compose(
    withRouter,
    connect(mapStateToProps, mapActionToProps)
)(Blogs);